<div class="formula-bar" [ngClass]="{'error-border': false}" [nbSpinner]="loading">
  <div class="d-flex flex-row-reverse align-items-center formula-input">
    <div class="mw-50-px mw-25 me-1 align-self-stretch mt-1-px">
      <div data-testid="dax-name" #nameInput class="name-input editable" spellcheck="false" contentEditable="true"
           [attr.data-placeholder]="calculateColumnMode === 'Column' ? 'column name' : calculateColumnMode === 'Measure' ? 'measure name' : 'name'"></div>
    </div>
    <div class="pt-1 gray-text align-self-stretch">
      =
    </div>
    <div class="ms-1 w-70 align-self-stretch mt-1-px autocomplete-container">
      <textarea  data-testid="formula-bar-input" #textBox [ngStyle]="{'height': textBoxHeight + 'px'}" class="name-input w-100 editable"
        spellcheck="false" placeholder="write formula here" [(ngModel)]="daxFormula" 
        (input)="onChangeFormula($event)"
        (click)="onChangeFormula($event)"
        (focusout)="onFocusOut()"></textarea>
      <ul data-testid="suggestions-dropdown-ul" #suggestionList *ngIf="suggestions.length" class="suggestions-dropdown custom-scroll ">
        <li *ngFor="let suggestion of suggestions">
          <button (click)="onSuggestionClick(suggestion)">
            <div class="suggestions-name">
              <morva-icons *ngIf="suggestion.optionType !== 'keyword'" class="icon-18" [icon]="getSuggestionIcon(suggestion)"></morva-icons>
              <span class="nowrap-text">
                {{ suggestion.prefix +  suggestion.name + suggestion.suffix }}
              </span>
            </div>
            <div *ngIf="suggestion.optionType === 'column'" class="suggestions-table-name">
              <span>
                {{suggestion.columnParentName}}
              </span>
            </div>
          </button>
        </li>
      </ul>
    </div>
  </div>
  <div class="formula-actions align-self-stretch align-items-baseline">
    <div class="help-title-container cursor-pointer" (click)="openDaxHelpDialog()">
      <morva-icons icon="helpCircle" class="icon-16"></morva-icons>
      <span class="help-title">راهنمای فرمول نویسی DAX</span>
    </div>
    <div class="vl"></div>
    <morva-icons (click)="deactivateCalculateColumnMode()" icon="close" class="me-2 icon-16 cursor-pointer"></morva-icons>
    <morva-icons data-testid="check-mark-icon" (click)="onSubmit()" icon="checkMark" class="cursor-pointer icon-16"></morva-icons>
  </div>
</div>
<div class="formula-error d-flex justify-content-between align-items-center w-100">
  <div *ngIf="clientErrors.length > 0" class="client-errors w-100">
    <div *ngFor="let clientError of clientErrors;" class="d-flex align-items-center w-100">
      <morva-icons icon="error" class="icon-12 mt-1"></morva-icons>
      <div class="me-1">{{clientError}}</div>
    </div>
  </div>
  <div *ngIf="serverError" class="server-errors w-100">
    <div class="d-flex align-items-center w-100 ltr bg-error">
      <morva-icons class="align-self-stretch ms-1 icon-12 mt-1" icon="error"></morva-icons>
      <div class="ms-1 text-start error-section">{{serverError}}</div>
    </div>
  </div>
</div>
